type Translate = (key: string) => string;

const hasSoldOutCapacityError = (errors: unknown): boolean => Array.isArray(errors) && errors.some((error) => typeof error === 'object' && error !== null && 'error' in error && error.error === 'sold_out');

export const resolveCheckoutErrorMessage = (error: any, translate: Translate): string => {
	const responseData = error?.response?.data;
	const soldOut = responseData?.error === 'sold_out' || hasSoldOutCapacityError(responseData?.event_caps_errors) || hasSoldOutCapacityError(responseData?.ticket_type_caps_errors);

	if (soldOut) {
		return translate('events.details.sold_out');
	}

	if (responseData?.message) {
		return responseData.message.toString();
	}

	return translate('common.error');
};
